import {Alert, Col, Form, Input, Modal, Row, Spin} from "antd";
import {MaskedInput} from "antd-mask-input";
import React, {useEffect, useState} from "react";
import Address from "../../models/Address";
import Vehicle from "../../models/Vehicle";
import api from "../../service/api";
import {IsValidAddress} from "../../utils/Validation";
import {Constants} from "../../utils/Constants";

interface RegisterAddressProps {
    cpfOrCnpj: number,
    formRef: any,
    vehicleData: Vehicle,
    setAddress?: any,
    setAddressToSchedule?: any
    setAddressSelected?: any
    isOpen?: boolean
    isInitialAddress?: boolean
}

const RegisterAddress: React.FC<RegisterAddressProps> = ({
                                                             cpfOrCnpj,
                                                             formRef,
                                                             vehicleData,
                                                             setAddress,
                                                             setAddressSelected,
                                                             setAddressToSchedule,
                                                             isOpen,
                                                             isInitialAddress
                                                         }) => {
    const [formNewAddress] = Form.useForm();
    const [isModalNewAddressVisible, setIsModalNewAddressVisible] = useState<boolean>(isOpen || false);
    const [loadAddressModal, setLoadAddressModal] = useState<boolean>(false);

    const [messageErrorCep, setMessageErrorCep] = useState<string>('');
    const [disableFieldsNewAddress, setDisableFieldsNewAddress] = useState<boolean>(true);
    const [disableFieldNumberAddress, setDisableFieldNumberAddress] = useState<boolean>(true);

    useEffect(() => {
        (!vehicleData.addressDto || !IsValidAddress(vehicleData.addressDto)) && setIsModalNewAddressVisible(true);
    }, [])

    useEffect(() => {
        isOpen !== undefined && setIsModalNewAddressVisible(isOpen);
    }, [isOpen])

    const onChangeZipCode = (e: any) => {
        if (!disableFieldsNewAddress && e.target.value.length < 9) {
            formNewAddress.resetFields(['address', 'county', 'city', 'state', 'complement', 'number'])
            setDisableFieldsNewAddress(true);
            setDisableFieldNumberAddress(true);
        } else if (e.target.value.length === 8) {
            onFindNewAddress();
        }
    }

    const onSaveNewAddress = () => {

        const number = formNewAddress.getFieldValue("number");

        if (!number || number.trim() === "") {
            setMessageErrorCep(Constants.EMPTY_NUMBER);
            return;
        }

        setLoadAddressModal(true);
        formNewAddress.validateFields()
            .then((newAddress: Address) => {
                if (!isInitialAddress) {
                    newAddress.isNew = true;
                }
                formRef.setFieldsValue({"addressDto": newAddress});
                setAddress && setAddress(newAddress);
                setAddressToSchedule && setAddressToSchedule(newAddress);
                setAddressSelected && setAddressSelected(newAddress.zipCode);
                vehicleData.addressDto = newAddress;
                formNewAddress.resetFields();
                setIsModalNewAddressVisible(false);
                setLoadAddressModal(false);
                setDisableFieldsNewAddress(true);
                setDisableFieldNumberAddress(true);
            })
            .catch((errorInfo) => {
                console.error("Erro ao validar os campos:", errorInfo);
                setLoadAddressModal(false);
            });
    };

    const onCloseAlert = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setMessageErrorCep('');
    };

    const onFindNewAddress = () => {
        setLoadAddressModal(true)
        formNewAddress.validateFields(["zipCode"]).then((newAddress: Address) => {
            console.log('---------- INICIO ----------');
            console.log('URL : scheduleExternal/findAddressByCep');
            console.log('cep: ' + newAddress.zipCode);

            api.get('scheduleExternal/findAddressByCep', {
                headers: {
                    cep: newAddress.zipCode,
                    // chassi: vehicleData.vehicleChassi,
                    // cpfOrCnpj: cpfOrCnpj
                }
            }).then(response => {
                console.log('response: ' + JSON.stringify(response.data));
                console.log('---------- FIM ----------');

                //Foi preciso converter o inteiro para string por conta da mudança na api
                //Antes vinha como string
                response.data.addressDto.zipCode = response.data.addressDto.zipCode.toString();
                formNewAddress.setFieldsValue(response.data.addressDto)
                if (response.data.addressDto.zipCode.endsWith("000")) {
                    setDisableFieldsNewAddress(false);
                } else {
                    setDisableFieldsNewAddress(true);
                }
                setDisableFieldNumberAddress(false);

            }).catch(error => {
                setLoadAddressModal(false);
                // error.response.data.errors.map((erro: string) => {
                //     return setMessageErrorCep(erro);
                // });
                if (error) {
                    return setMessageErrorCep("CEP não encontrado!")
                }

            });
        }).catch(error => {
            setLoadAddressModal(false);
            // if (error.response) {
            //     error.response.data.errors.map((erro: string) => {
            //         return setMessageErrorCep(erro);
            //     });
            // }
            if (error) {
                return setMessageErrorCep("CEP não encontrado!")
            }
        });
        setLoadAddressModal(false);
    }

    return (
        <Modal title="Informe Endereço" visible={isModalNewAddressVisible} width={768}
               onOk={disableFieldNumberAddress ? onFindNewAddress : onSaveNewAddress}
               okText={disableFieldNumberAddress ? 'Pesquisar' : 'Salvar'} closable={false}
               cancelButtonProps={{style: {display: 'none'}}}>
            <Spin spinning={loadAddressModal}>
                <Form
                    form={formNewAddress}
                    layout="vertical">
                    {messageErrorCep !== '' &&
                        <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align="middle">
                            <Col span={24}>
                                <Alert
                                    message="Atenção"
                                    description={messageErrorCep}
                                    type="warning"
                                    showIcon
                                    closable
                                    onClose={onCloseAlert}
                                />
                            </Col>
                        </Row>
                    }
                    <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align="middle">
                        <Col span={12}>
                            <Form.Item
                                label="Buscar CEP para incluir novo endereço"
                                rules={[{required: true, message: 'Informe o CEP'}, {
                                    validator: (_, value: string) =>
                                        !value || value.length === 8 ? Promise.resolve() : Promise.reject(new Error('CEP incompleto'))
                                }]} name="zipCode">
                                <MaskedInput type='text' mask={'00000000'} maskOptions={{lazy: true, overwrite: false,}}
                                             placeholder="Informe o cep" onKeyUp={onChangeZipCode}/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Número" rules={[{required: true, message: 'Informe o número'}]}
                                       name="number" initialValue="">
                                <Input placeholder="Número" disabled={disableFieldNumberAddress}/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align="middle">
                        <Col span={24}>
                            <Form.Item label="Endereço" name="address">
                                <Input placeholder="Endereço" disabled={disableFieldsNewAddress}/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align="middle">
                        <Col span={10} xs={16}>
                            <Form.Item label="Bairro" name="county">
                                <Input placeholder="Bairro" disabled={disableFieldsNewAddress}/>
                            </Form.Item>
                        </Col>
                        <Col span={3} xs={8}>
                            <Form.Item label="Complemento" name="complement">
                                <Input placeholder="Complemento" disabled={disableFieldNumberAddress}/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align="middle">
                        <Col span={10} xs={16}>
                            <Form.Item label="Cidade" name="city">
                                <Input placeholder="Cidade" disabled={disableFieldsNewAddress}/>
                            </Form.Item>
                        </Col>
                        <Col span={3} xs={8}>
                            <Form.Item label="Estado" name="state">
                                <Input placeholder="UF" disabled={disableFieldsNewAddress}/>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Spin>
        </Modal>
    )
}

export default RegisterAddress
